import { cn } from "../lib/utils";

export const DEFAULT_CATEGORY_COLOR = "#10b981";

export const CATEGORY_COLOR_SWATCHES = [
  "#10b981",
  "#3b82f6",
  "#8b5cf6",
  "#ec4899",
  "#ef4444",
  "#f97316",
  "#eab308",
  "#14b8a6",
  "#06b6d4",
  "#64748b",
];

function isHexColor(value) {
  return /^#[0-9a-f]{6}$/i.test(value || "");
}

export function ColorPicker({ value, onChange, disabled = false, swatches = CATEGORY_COLOR_SWATCHES }) {
  const inputValue = isHexColor(value) ? value : DEFAULT_CATEGORY_COLOR;

  return (
    <div className={cn("space-y-3", disabled && "opacity-70")}>
      <div className="flex items-center gap-3">
        <span
          className="h-9 w-9 shrink-0 rounded-full border border-border"
          style={{ backgroundColor: value || DEFAULT_CATEGORY_COLOR }}
          aria-hidden="true"
        />
        <input
          type="color"
          value={inputValue}
          disabled={disabled}
          onChange={(event) => onChange?.(event.target.value)}
          className="h-10 w-full cursor-pointer rounded-md border border-input bg-background p-1 disabled:cursor-not-allowed"
          aria-label="Cor da categoria"
        />
      </div>
      <div className="grid grid-cols-10 gap-2">
        {swatches.map((color) => (
          <button
            key={color}
            type="button"
            disabled={disabled}
            aria-label={`Selecionar cor ${color}`}
            className={cn(
              "h-7 rounded-full border border-border transition-transform hover:scale-105 focus:outline-none focus:ring-2 focus:ring-ring disabled:cursor-not-allowed",
              value === color && "ring-2 ring-ring ring-offset-2 ring-offset-background"
            )}
            style={{ backgroundColor: color }}
            onClick={() => onChange?.(color)}
          />
        ))}
      </div>
    </div>
  );
}
